import React, {PureComponent} from "react";
import {Modal} from "react-responsive-modal";
import $ from "jquery";
import {formatDate, formatTime} from "../functions/utils";
import Alert from "react-s-alert";
import {
    confirmIdentity,
    connectSocket,
    subscribeDashToServer,
    subscribeToPitInfo,
    closeSocket
} from "../functions/api";

import {withTranslation} from "react-i18next";
import {withCookies} from "react-cookie";

const serverIP = process.env.REACT_APP_SERVER_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;

let invalidPitStyle = {
    color: "#ff1f00",
    fontSize: 20,
    fontWeight: "bold",
};

class PopoutLivePitSpeed extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            pitLaneSpeedLimit: 60,
            pitLaneMinTime: 90,
            carList: [],
            tableRows: [],
            show: false,
            modalData: [],
            timezone: null,
            orderSwitch: "asc",
            orderType: "nr",
            confirmedOrg: true,
            searchVehicle: "",
        };

        this.getPitDetails = this.getPitDetails.bind(this);
        this.getCarInfo = this.getCarInfo.bind(this);
        this.reorderCarList = this.reorderCarList.bind(this);
        this.handleShowModal = this.handleShowModal.bind(this);

        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handlePitLaneSpeedLimitChange = this.handlePitLaneSpeedLimitChange.bind(this);

        this.handlePitLaneMinTimeChange = this.handlePitLaneMinTimeChange.bind(this);
        this.updateLimits = this.updateLimits.bind(this);
        this.handleChangeSort = this.handleChangeSort.bind(this);
        this.handleChangeVehicleSearch = this.handleChangeVehicleSearch.bind(this);

        this.comparePitStatus = this.comparePitStatus.bind(this);
        this.compareLivery = this.compareLivery.bind(this);
        this.comparePitStops = this.comparePitStops.bind(this);
        this.compareFastestPit = this.compareFastestPit.bind(this);
        this.compareTotalPitTime = this.compareTotalPitTime.bind(this);
        this.comparePitMaxSpeed = this.comparePitMaxSpeed.bind(this);
        this.comparePenaltyPits = this.comparePenaltyPits.bind(this);
        this.compareRaceStatus = this.compareRaceStatus.bind(this);

        this.popoutDetail = this.popoutDetail.bind(this);
        this.makeTableRows = this.makeTableRows.bind(this);
    }

    /* LIFE CYCLE */
    componentDidMount() {
        $(".loading").fadeIn();
        confirmIdentity(this.props.cookies.get("authToken"), this.props.match.params.userID, this.props.match.params.eventID, (confirmed) => {
            if (confirmed) {
                this.getPitDetails((status) => {
                    this.getCarInfo((status) => {
                        this.reorderCarList(null);
                    });
                });
                // Connect Socket
                connectSocket(this.props.cookies.get("authToken"), null, this.props.match.params.sessionID, this.props.match.params.eventID, "LIVEPITSPEED", (msg) => {
                    console.log("[PIT SPEED MONITOR]" + msg);
                    let counter = 0;
                    // DS
                    subscribeDashToServer(this.props.match.params.eventID, this.props.match.params.sessionID, () => {
                        console.log("[LAP TIMES] DEDICATED STREAM SUBSCRIBED");
                    });

                    subscribeToPitInfo(this.props.match.params.eventID, false, (err, pitInfo) => {
                        if (counter >= 150) {
                            this.getCarInfo((status) => {
                                this.reorderCarList(null);
                            });
                            counter = 0;
                        }
                        if (this.state.timezone) {
                            this.reorderCarList(pitInfo);
                        }
                        counter++;
                    });
                });
            } else {
                this.setState({
                    confirmed: false,
                });
            }
        });
    }

    componentWillUnmount() {
        subscribeDashToServer(this.props.match.params.eventID, this.props.match.params.sessionID, () => {
            console.log("[DASHBOARD] DEDICATED STREAM UNSUBSCRIBED");
        });
        subscribeToPitInfo(this.props.location.state.eventID, true, null);
        closeSocket();
    }

    /* GET DATA */
    getCarInfo(callback) {
        console.log("[PIT SPEED MONITOR] Getting car pits info ...");
        const helper = this;
        $.ajax({
            type: "POST",
            url: serverIP + ":" + backendPort + "/dashboard/getCarListLivePit",
            headers: {
                "authorization": helper.props.cookies.get("authToken"),
            },
            data: {
                sessionID: helper.props.match.params.sessionID,
            },
            success: function (data) {
                if (data.length > 0) {
                    helper.setState({
                        carList: data,
                    }, () => {
                        callback("ok");
                    });
                } else {
                    $(".loading").fadeOut();
                    callback("nok");
                }
            }, error: function (err) {
                if (err) {
                    console.error("Error:", err);
                }
                callback("nok");
            }
        });
    }

    getPitDetails(callback) {
        const helper = this;
        $.ajax({
            type: "POST",
            url: serverIP + ":" + backendPort + "/dashboard/getPitDetails",
            headers: {
                "authorization": helper.props.cookies.get("authToken"),
            },
            data: {
                userID: helper.props.match.params.userID,
                sessionID: helper.props.match.params.sessionID,
                speedLimit: helper.state.pitLaneSpeedLimit,
                pitLimit: helper.state.pitLaneMinTime,
            },
            success: function (data) {
                helper.setState({
                    timezone: data.timezone,
                    pitLaneSpeedLimit: data.pitlane_speed_limit,
                    pitLaneMinTime: data.pit_minimum_time,
                    map_center_zoom_level: data.map_center_zoom_level,
                    map_rotation: data.map_rotation,
                    pit_entry_lat: data.pit_entry_lat,
                    pit_entry_lng: data.pit_entry_lng,
                    pit_exit_lat: data.pit_exit_lat,
                    pit_exit_lng: data.pit_exit_lng,
                    session_start_timestamp: data.start_timestamp
                }, () => {
                    callback("ok");
                });
            }, error: function (err) {
                if (err) {
                    console.log(err);
                }
                callback("nok");
            }
        });
    }

    /* POPOUT */
    popoutDetail(e) {
        e.stopPropagation();
        e.preventDefault();
        let parts = e.target.value.split("_");
        window.open(
            "/pitDetails/" +
            this.props.match.params.eventID + "/" +
            this.props.match.params.sessionID + "/" +
            parts[0] + "/" +
            parts[1] + "/" +
            parts[2] + "/" +
            this.props.match.params.userID + "/" +
            this.state.map_center_zoom_level + "/" +
            this.state.map_rotation + "/" +
            this.state.pit_entry_lat + "/" +
            this.state.pit_entry_lng + "/" +
            this.state.pit_exit_lat + "/" +
            this.state.pit_exit_lng + "/",
            "pitDetail",
            "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,left=20,top=100,width=800,height=850"
        );
    }

    /* HANDLERS */
    handlePitLaneSpeedLimitChange(e) {
        e.preventDefault();
        this.setState({
            pitLaneSpeedLimit: e.target.value,
        });
    }

    handlePitLaneMinTimeChange(e) {
        e.preventDefault();
        this.setState({
            pitLaneMinTime: e.target.value,
        });
    }

    updateLimits(e) {
        e.preventDefault();
        const helper = this;
        $.ajax({
            type: "POST",
            url: serverIP + ":" + backendPort + "/dashboard/updatePitLimits",
            headers: {
                "authorization": helper.props.cookies.get("authToken"),
            },
            data: {
                sessionID: helper.props.match.params.sessionID,
                speedLimit: helper.state.pitLaneSpeedLimit,
                pitLimit: helper.state.pitLaneMinTime,
            },
            success: function (data) {
                Alert.success('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + helper.props.t("pitLimitsUpdated") + '!</span>', {
                    position: "top-right",
                    effect: "genie",
                    beep: false,
                    timeout: 5000,
                    offset: 150
                });
            }, error: function (err) {
                Alert.danger('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + helper.props.t("pitLimitsError") + '.</span>', {
                    position: "top-right",
                    effect: "genie",
                    beep: false,
                    timeout: 5000,
                    offset: 150
                });
            }
        });
    }

    handleShowModal(e) {
        let parts = e.target.value.split("_");
        let index = parts[0];
        let action = parts[1];
        switch (action) {
            case "history": {
                this.setState({
                    modalData: this.state.carList[index].pit_data.pitHistory,
                }, () => {
                    this.setState({
                        show: true,
                    });
                });
                break;
            }
            case "overLimit": {
                this.setState({
                    modalData: this.state.carList[index].pit_data.penaltyPit,
                }, () => {
                    this.setState({
                        show: true,
                    });
                });
                break;
            }
            default: {
                break;
            }
        }
    }

    handleCloseModal() {
        this.setState({
            show: false,
        });
    }

    handleChangeVehicleSearch(e) {
        e.preventDefault();
        if (!isNaN(e.target.value)) {
            let number = e.target.value;
            this.setState({
                searchVehicle: number,
            }, () => {
                this.makeTableRows();
            });
        }
    }

    /* SORT METHODS */
    reorderCarList(pitInfo) {

        let temp = this.state.carList.slice();

        for (let c = 0; c < this.state.carList.length; c++) {
            temp[c].pit_live = {
                text: "---",
                textColor: "#FFFFFF",
                spd: 1000,
                sts: -10,
                rsi: -1,
            };

            if (pitInfo) {
                for (let i = 0; i < pitInfo.length; i++) {
                    if (temp[c].car_id === pitInfo[i].cid) {
                        temp[c].pit_live = pitInfo[i];
                        switch (pitInfo[i].sts) {
                            case (0): {
                                temp[c].pit_live.text = this.props.t("onTrack").toUpperCase();
                                temp[c].pit_live.textColor = "#FFFFFF";
                                break;
                            }
                            case (1): {
                                temp[c].pit_live.text = this.props.t("pitEntry").toUpperCase();
                                temp[c].pit_live.textColor = "#007bff";
                                break;
                            }
                            case (2): {
                                temp[c].pit_live.text = this.props.t("box").toUpperCase();
                                temp[c].pit_live.textColor = "#ffc700";
                                break;
                            }
                            case (3): {
                                temp[c].pit_live.text = this.props.t("pitExit").toUpperCase();
                                temp[c].pit_live.textColor = "#007bff";
                                break;
                            }
                            case (4): {
                                temp[c].pit_live.text = this.props.t("outLap").toUpperCase();
                                temp[c].pit_live.textColor = "#00ff1b";
                                break;
                            }
                            default: {
                                temp[c].pit_live.text = "---";
                                temp[c].pit_live.textColor = "#ffffff";
                                break;
                            }
                        }
                        break;
                    }
                }
            }
        }

        this.setState({
            carList: temp,
        }, () => {
            switch (this.state.orderType) {
                case "nr": {
                    this.state.carList.sort(this.compareLivery);
                    break;
                }
                case "numPits": {
                    this.state.carList.sort(this.comparePitStops);
                    break;
                }
                case "fastestPit": {
                    this.state.carList.sort(this.compareFastestPit);
                    break;
                }
                case "totalPitTime": {
                    this.state.carList.sort(this.compareTotalPitTime);
                    break;
                }
                case "maxSpeedInPit": {
                    this.state.carList.sort(this.comparePitMaxSpeed);
                    break;
                }
                case "numOverEntry": {
                    this.state.carList.sort(this.comparePenaltyPits);
                    break;
                }
                case "state": {
                    this.state.carList.sort(this.comparePitStatus);
                    break;
                }
                default: {
                    break;
                }
            }
            this.state.carList.sort(this.compareRaceStatus);
            this.makeTableRows();
        });
    }

    handleChangeSort(e) {
        this.setState({
            orderType: e.target.id,
            orderSwitch: this.state.orderSwitch === "asc" ? "desc" : "asc",
        }, () => {
            this.reorderCarList(null);
        });
    }

    comparePitStatus(a, b) {
        if (this.state.orderSwitch === "asc") {
            if (a.pit_live.sts > b.pit_live.sts) {
                return -1;
            } else if (a.pit_live.sts < b.pit_live.sts) {
                return 1;
            }
        } else {
            if (a.pit_live.sts < b.pit_live.sts) {
                return -1;
            } else if (a.pit_live.sts > b.pit_live.sts) {
                return 1;
            }
        }
    }

    compareLivery(a, b) {
        if (this.state.orderSwitch === "asc") {
            if (a.car_info.livery_number < b.car_info.livery_number) {
                return -1;
            } else if (a.car_info.livery_number > b.car_info.livery_number) {
                return 1;
            }
        } else {
            if (a.car_info.livery_number > b.car_info.livery_number) {
                return -1;
            } else if (a.car_info.livery_number < b.car_info.livery_number) {
                return 1;
            }
        }
    }

    comparePitStops(a, b) {
        if (this.state.orderSwitch === "asc") {
            if (a.pit_data.numStops < b.pit_data.numStops) {
                return -1;
            } else if (a.pit_data.numStops > b.pit_data.numStops) {
                return 1;
            }
        } else {
            if (a.pit_data.numStops > b.pit_data.numStops) {
                return -1;
            } else if (a.pit_data.numStops < b.pit_data.numStops) {
                return 1;
            }
        }
    }

    compareFastestPit(a, b) {
        if (this.state.orderSwitch === "asc") {
            if (a.pit_data.fastestPit < b.pit_data.fastestPit) {
                return -1;
            } else if (a.pit_data.fastestPit > b.pit_data.fastestPit) {
                return 1;
            }
        } else {
            if (a.pit_data.fastestPit > b.pit_data.fastestPit) {
                return -1;
            } else if (a.pit_data.fastestPit < b.pit_data.fastestPit) {
                return 1;
            }
        }
    }

    compareTotalPitTime(a, b) {
        if (this.state.orderSwitch === "asc") {
            if (a.pit_data.pitTime < b.pit_data.pitTime) {
                return -1;
            } else if (a.pit_data.pitTime > b.pit_data.pitTime) {
                return 1;
            }
        } else {
            if (a.pit_data.pitTime > b.pit_data.pitTime) {
                return -1;
            } else if (a.pit_data.pitTime < b.pit_data.pitTime) {
                return 1;
            }
        }
    }

    comparePitMaxSpeed(a, b) {
        if (this.state.orderSwitch === "asc") {
            if (a.pit_data.pitMaxSpeed.max_speed < b.pit_data.pitMaxSpeed.max_speed) {
                return -1;
            } else if (a.pit_data.pitMaxSpeed.max_speed > b.pit_data.pitMaxSpeed.max_speed) {
                return 1;
            }
        } else {
            if (a.pit_data.pitMaxSpeed.max_speed > b.pit_data.pitMaxSpeed.max_speed) {
                return -1;
            } else if (a.pit_data.pitMaxSpeed.max_speed < b.pit_data.pitMaxSpeed.max_speed) {
                return 1;
            }
        }
    }

    comparePenaltyPits(a, b) {
        if (this.state.orderSwitch === "asc") {
            if (a.pit_data.penaltyPit.length < b.pit_data.penaltyPit.length) {
                return -1;
            } else if (a.pit_data.penaltyPit.length > b.pit_data.penaltyPit.length) {
                return 1;
            }
        } else {
            if (a.pit_data.penaltyPit.length > b.pit_data.penaltyPit.length) {
                return -1;
            } else if (a.pit_data.penaltyPit.length < b.pit_data.penaltyPit.length) {
                return 1;
            }
        }
    }

    compareRaceStatus(a, b) {
        if (a.car_info.rsi < b.car_info.rsi) {
            return -1;
        } else if (a.car_info.rsi > b.car_info.rsi) {
            return 1;
        }
    }

    /* RENDER METHODS */
    makeTableRows() {
        if (this.state.carList.length > 0) {
            let rows = [];
            for (let i = 0; i < this.state.carList.length; i++) {

                if (!isNaN(parseInt(this.state.searchVehicle))) {
                    if (("" + this.state.carList[i].car_info.livery_number).indexOf(this.state.searchVehicle) === -1) {
                        continue;
                    }
                }

                let statusColor = "";
                let statusText = "";
                let statusOpacity = "";

                switch (this.state.carList[i].car_info.rsi) {
                    case (2): {
                        statusColor = "#be2000";
                        statusText = "DNF - ";
                        statusOpacity = "40";
                        break;
                    }
                    case (3): {
                        statusColor = "#e09d00";
                        statusText = "DNS - ";
                        statusOpacity = "40";
                        break;
                    }
                    default: {
                        statusColor = "";
                        statusText = "";
                        statusOpacity = "";
                        break;
                    }
                }

                let speedStyle = {
                    color: this.state.carList[i].pit_live && this.state.carList[i].pit_live.spd > this.state.pitLaneSpeedLimit && [1, 2, 3].includes(this.state.carList[i].pit_live.sts) ? "#ff1f00" : "#FFFFFF",
                    fontSize: [1, 2, 3].includes(this.state.carList[i].pit_live.sts) ? 45 : 25,
                    fontWeight: [1, 2, 3].includes(this.state.carList[i].pit_live.sts) ? "bold" : "normal",
                };

                let statusStyle = {
                    color: this.state.carList[i].pit_live.textColor,
                    fontSize: this.state.carList[i].pit_live.sts !== 0 ? 30 : 25,
                    fontWeight: "bold",
                };

                let rowStyle = {
                    textAlign: "center",
                    backgroundColor: statusColor + statusOpacity,
                };

                rows.push(
                    <tr
                        key={this.state.carList[i].car_info.livery_number}
                        className={"onHover App_white_text"}
                        style={rowStyle}
                    >
                        <td>#{this.state.carList[i].car_info.livery_number}</td>
                        <td style={{textAlign: "left"}}>{statusText + this.state.carList[i].car_info.team_name}</td>
                        <td style={statusStyle}>{this.state.carList[i].pit_live.text}</td>
                        <td style={speedStyle}>{this.state.carList[i].pit_live.spd && this.state.carList[i].pit_live.spd < 500 ? this.state.carList[i].pit_live.spd : "---"}</td>
                        <td>
                            <button
                                style={{background: "#ff0003", fontWeight: "bold"}}
                                type={"button"}
                                className={"btn App_white_text_liveMaxes button"}
                                value={i + "_history"}
                                onClick={this.handleShowModal}
                                disabled={this.state.carList[i].pit_data.pitHistory.length === 0}
                            >
                                {this.state.carList[i].pit_data.numStops} pits
                            </button>
                        </td>
                        <td className={this.state.carList[i].pit_data.fastestPit < this.state.pitLaneMinTime * 1000 ? "App_penalty" : ""}>{formatTime(this.state.carList[i].pit_data.fastestPit)}</td>
                        <td>{formatTime(this.state.carList[i].pit_data.pitTime)}</td>
                        <td className={this.state.carList[i].pit_data.pitMaxSpeed && this.state.carList[i].pit_data.pitMaxSpeed.max_speed > this.state.pitLaneSpeedLimit ? "App_penalty" : ""}>
                            {this.state.carList[i].pit_data.pitMaxSpeed ? (
                                this.state.carList[i].pit_data.pitMaxSpeed.max_speed + " km/h (Lap " + this.state.carList[i].pit_data.pitMaxSpeed.lap_number + ")"
                            ) : (
                                "---"
                            )}
                        </td>
                        <td>
                            <button
                                style={{background: "#ff0003", fontWeight: "bold"}}
                                type="button"
                                className={"btn App_white_text_liveMaxes button"}
                                value={i + "_overLimit"}
                                onClick={this.handleShowModal}
                                disabled={this.state.carList[i].pit_data.penaltyPit.length === 0}
                            >
                                {this.state.carList[i].pit_data.penaltyPit.length + " " + this.props.t("pits")}
                            </button>
                        </td>
                        <td>
                            <span>{this.state.carList[i].pit_data.pitHistory.length > 0 ? formatDate(this.state.carList[i].pit_data.pitHistory[0].entry_time, this.state.timezone) : "---"}</span><br/>
                            <span>{this.state.carList[i].pit_data.pitHistory.length > 0 ? formatTime(this.state.carList[i].pit_data.pitHistory[0].entry_time - (this.state.session_start_timestamp * 1000)).substring(0, 8) : "---"}</span>
                        </td>
                        <td style={
                            this.state.carList[i].pit_data.pitHistory.length > 0 && this.state.carList[i].pit_data.pitHistory[0].exit_time - this.state.carList[i].pit_data.pitHistory[0].entry_time < this.state.pitLaneSpeedLimit * 1000 ? invalidPitStyle : {}
                        }>{this.state.carList[i].pit_data.pitHistory.length > 0 ? formatTime(this.state.carList[i].pit_data.pitHistory[0].exit_time - this.state.carList[i].pit_data.pitHistory[0].entry_time) : "---"}</td>
                    </tr>
                );
            }

            this.setState({
                tableRows: rows,
            }, () => {
                $(".loading").fadeOut();
            });
        }
    }

    render() {
        if (this.state.confirmedOrg) {
            return (
                <>
                    <Alert stack={{limit: 10}} html={true}/>
                    <div className="loading">
                        <div className={"loading-text hidden-sm hidden-xs"}>{this.props.t("processing")}</div>
                    </div>
                    <div className={"row App_categoryHeader"} style={{padding: 10}}>
                        <div className={"col-xs-7 col-md-4"}>
                            <div className={"col-xs-12"}>
                                <div className={"col-xs-9"}>
                                    <label className={"toolTipStyle"}>{this.props.t("pitLaneSpeedLimit")} (km/h)</label>
                                </div>
                                <div className={"col-xs-3"}>
                                    <input
                                        type={"number"}
                                        style={{borderColor: "#ea1f24", borderWidth: "medium"}}
                                        className={"form-control App_black_text"}
                                        value={this.state.pitLaneSpeedLimit}
                                        placeholder={this.props.t("enterValue")}
                                        onChange={this.handlePitLaneSpeedLimitChange}
                                    />
                                </div>
                            </div>
                            <div className={"col-xs-12"}>
                                <div className={"col-xs-9"}>
                                    <label className={"toolTipStyle"}>{this.props.t("pitLaneMinimumTime")} (sec)</label>
                                </div>
                                <div className={"col-xs-3"}>
                                    <input
                                        type={"number"}
                                        className={"form-control App_black_text"}
                                        style={{borderColor: "#ea1f24", borderWidth: "medium"}}
                                        value={this.state.pitLaneMinTime}
                                        placeholder={this.props.t("enterValue")}
                                        onChange={this.handlePitLaneMinTimeChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={"col-xs-5 col-md-6"} style={{paddingLeft: 0}}>
                            <button
                                style={{background: "#ff0003", fontWeight: "bold"}}
                                type={"button"}
                                className={"btn App_white_text_liveMaxes button"}
                                onClick={this.updateLimits}
                            >
                                {this.props.t("updateLimits").toUpperCase()}
                            </button>
                        </div>
                    </div>
                    <div className={"App_lapTableContainerStyle table-scroll-parent"} style={{height: "86vh"}}>
                        <div className={"table-scroll-child"}>
                            <table className={"table table-hover"}>
                                <thead>
                                <tr>
                                    <th colSpan={$(window).width() > 1200 ? 1 : 2}>
                                        <input
                                            className={"form-control App_black_text"}
                                            style={{border: "2px solid #ed2126", height: 40}}
                                            value={this.state.searchVehicle}
                                            placeholder={"000"}
                                            type={"text"}
                                            onChange={this.handleChangeVehicleSearch}
                                        />
                                    </th>
                                    <th className={"App_header"} colSpan={3}/>
                                    <th className={"App_header"} colSpan={5} style={{whiteSpace: "nowrap", borderLeft: "2px solid white"}}>{this.props.t("overallPits").toUpperCase()}</th>
                                    <th className={"App_header"} colSpan={2} style={{whiteSpace: "nowrap", borderLeft: "2px solid white"}}>{this.props.t("latestPit").toUpperCase()}</th>
                                </tr>
                                <tr style={{whiteSpace: "nowrap"}}>
                                    <th id={"nr"} className={"App_header"} style={{cursor: "pointer", width: "5%"}} onClick={this.handleChangeSort}><i className="fas fa-arrows-alt-v"/> {this.props.t("nr").toUpperCase()}</th>
                                    <th className={"App_header"} style={{textAlign: "left", width: "15%"}}>{this.props.t("team").toUpperCase()}</th>
                                    <th id={"state"} className={"App_header"} style={{cursor: "pointer"}} onClick={this.handleChangeSort}><i className="fas fa-arrows-alt-v"/> {this.props.t("state").toUpperCase()}</th>
                                    <th className={"App_header"}>{this.props.t("speed").toUpperCase()}</th>
                                    <th id={"numPits"} className={"App_header"} style={{cursor: "pointer", borderLeft: "2px solid white"}} onClick={this.handleChangeSort}><i className="fas fa-arrows-alt-v"/> {this.props.t("pitStops").toUpperCase()}</th>
                                    <th id={"fastestPit"} className={"App_header"} style={{cursor: "pointer"}} onClick={this.handleChangeSort}><i className="fas fa-arrows-alt-v"/> {this.props.t("fastestPit").toUpperCase()}</th>
                                    <th id={"totalPitTime"} className={"App_header"} style={{cursor: "pointer"}} onClick={this.handleChangeSort}><i className="fas fa-arrows-alt-v"/> {this.props.t("totalPitTime").toUpperCase()}</th>
                                    <th id={"maxSpeedInPit"} className={"App_header"} style={{cursor: "pointer"}} onClick={this.handleChangeSort}><i className="fas fa-arrows-alt-v"/> {this.props.t("maxSpd").toUpperCase()} (PIT)</th>
                                    <th id={"numOverEntry"} className={"App_header"} style={{cursor: "pointer"}} onClick={this.handleChangeSort}><i className="fas fa-arrows-alt-v"/> {this.props.t("pitWithPenalty").toUpperCase()}</th>
                                    <th className={"App_header"} style={{borderLeft: "2px solid white"}}>{this.props.t("pitEntry").toUpperCase()}</th>
                                    <th className={"App_header"}>{this.props.t("time").toUpperCase()}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.tableRows}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <Modal open={this.state.show}
                           onClose={this.handleCloseModal}
                           center={false}
                           classNames={{modal: "large-modal"}}
                           showCloseIcon={false}
                    >
                        <div className={"modal-header"}>
                            <div className={"modal-title"}>
                                <b className={"App_header"} style={{color: "#000000"}}>{this.props.t("pitHistory")}</b>
                            </div>
                        </div>
                        <div className={"modal-body"}>
                            <div className={"table-scroll-parent"} style={{height: "70vh"}}>
                                <table className={"table table-hover table-condensedable-scroll-child"}>
                                    <thead>
                                    <tr>
                                        <th colSpan={1}/>
                                        <th colSpan={4} className={"App_header"} style={{color: "#000000", borderLeft: "2px solid black"}}>{this.props.t("time").toUpperCase()}</th>
                                        <th colSpan={3} className={"App_header"} style={{color: "#000000", borderRight: "2px solid black", borderLeft: "2px solid black"}}>{this.props.t("speed").toUpperCase()}</th>
                                        <th colSpan={1} className={"App_header"} style={{color: "#000000"}}>{this.props.t("pit").toUpperCase()}</th>
                                    </tr>
                                    <tr style={{whiteSpace: "nowrap"}}>
                                        <th className={"App_header"} style={{color: "#000000"}}>{this.props.t("lap").toUpperCase()}</th>
                                        <th className={"App_header"} style={{color: "#000000", borderLeft: "2px solid black"}}>{this.props.t("entry").toUpperCase()}</th>
                                        <th className={"App_header"} style={{color: "#000000"}}>{this.props.t("session").toUpperCase()}</th>
                                        <th className={"App_header"} style={{color: "#000000"}}>{this.props.t("exit").toUpperCase()}</th>
                                        <th className={"App_header"} style={{color: "#000000"}}>{this.props.t("session").toUpperCase()}</th>
                                        <th className={"App_header"} style={{color: "#000000", borderLeft: "2px solid black"}}>{this.props.t("max").toUpperCase()}</th>
                                        <th className={"App_header"} style={{color: "#000000"}}>{this.props.t("entry").toUpperCase()}</th>
                                        <th className={"App_header"} style={{color: "#000000"}}>{this.props.t("exit").toUpperCase()}</th>
                                        <th className={"App_header"} style={{color: "#000000", borderLeft: "2px solid black"}}>{this.props.t("duration").toUpperCase()}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.modalData.map((pit) => {
                                        return (
                                            <tr
                                                key={pit.uuid}
                                                className={"App_black_text"}
                                                style={{textAlign: "center"}}
                                            >
                                                <td style={{width: "2%"}}>
                                                    <button
                                                        style={{background: "#ff0003", fontWeight: "bold", color: "#ffffff"}}
                                                        type={"button"}
                                                        className={"btn button"}
                                                        value={pit.car_id + "_" + pit.entry_time + "_" + pit.exit_time}
                                                        onClick={this.popoutDetail}
                                                    >
                                                        {pit.lap_number}
                                                    </button>
                                                </td>
                                                <td style={{borderLeft: "2px solid black"}}>{formatDate(pit.entry_time, this.state.timezone)}</td>
                                                <td>{formatTime(pit.entry_time - (this.state.session_start_timestamp * 1000))}</td>
                                                <td>{formatDate(pit.exit_time, this.state.timezone)}</td>
                                                <td>{formatTime(pit.exit_time - (this.state.session_start_timestamp * 1000))}</td>
                                                <td className={pit.max_speed > this.state.pitLaneSpeedLimit ? "App_penalty" : ""} style={{borderLeft: "2px solid black"}}>
                                                    {pit.max_speed && pit.max_speed < 500 ? pit.max_speed + " km/h" : "---"}
                                                </td>
                                                <td className={pit.entry_speed > this.state.pitLaneSpeedLimit ? "App_penalty" : ""}>
                                                    {pit.entry_speed && pit.entry_speed < 500 ? pit.entry_speed + " km/h" : "---"}
                                                </td>
                                                <td className={pit.exit_speed > this.state.pitLaneSpeedLimit ? "App_penalty" : ""}>
                                                    {pit.exit_speed && pit.exit_speed < 500 ? pit.exit_speed + " km/h" : "---"}
                                                </td>
                                                <td className={(pit.exit_time - pit.entry_time) < this.state.pitLaneMinTime * 1000 ? "App_penalty" : ""} style={{borderLeft: "2px solid black"}}>
                                                    {formatTime(pit.exit_time - pit.entry_time)}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className={"modal-footer"}>
                            <button
                                onClick={this.handleCloseModal}
                                className={"btn App_header button"}
                                style={{background: "#ff0003", color: "#FFFFFF"}}
                            >{this.props.t("close")}
                            </button>
                        </div>
                    </Modal>
                </>
            );
        } else {
            return (
                <div/>
            );
        }
    }
}

export default withTranslation("translations")(withCookies(PopoutLivePitSpeed));
